"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiCardMedia = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

/**
 * MuiCardMedia is used in storyblok redirect to react routes
 */
var MuiCardMedia = function MuiCardMedia(_ref) {
  var rootClass = _ref.rootClass,
      alt = _ref.alt,
      height = _ref.height,
      image = _ref.image,
      title = _ref.title;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    height: height
  });

  return /*#__PURE__*/_react.default.createElement(_CardMedia.default, {
    className: styles.root,
    alt: alt,
    image: image,
    title: title
  });
};

exports.MuiCardMedia = MuiCardMedia;
var _default = MuiCardMedia;
exports.default = _default;
MuiCardMedia.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * height is requred for media to display
   * value in px
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /** alt text for image */
  alt: _propTypes.default.string.isRequired,

  /** title text for image */
  title: _propTypes.default.string.isRequired,

  /**
   * url for image
   * Image to be displayed as a background image
   * */
  image: _propTypes.default.string.isRequired
};
MuiCardMedia.defaultProps = {
  rootClass: [],
  height: '140px'
};